





import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'DocumentExpiryDate',
})
export default class extends GiganautVue {

	@Prop({required: true})
	expiresAt: Date;

	get expired() {
		const currentDate = new Date()
		const expiresAtDate = new Date(this.expiresAt);
		if (currentDate > expiresAtDate) {
			return true;
		}
		return false;
	}

	get textColor() {
		const currentDate = new Date()
		const expiresAtDate = new Date(this.expiresAt);
		if (currentDate > expiresAtDate) {
			return "red--text"
		}
		currentDate.setMonth(currentDate.getMonth() + 1);
		if (currentDate > expiresAtDate) {
			return "orange--text"
		}
	    else return "black--text"
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		//classes.push("overline");
		return classes;
	}
}
